<bs-alert [type]="alertType" [message]="notificationMessage()"></bs-alert>
